import { z } from 'zod'

import { IError } from '@/config/http/http.helpers'

export type ILoadingStates = 'initial' | 'loading' | 'success' | IError

export const ApiBaseResponseSchema = z.object({
  status: z.union([z.string(), z.number()]),
  message: z.string()
})
export type ApiBaseResponse = z.infer<typeof ApiBaseResponseSchema>
